import { useCallback, useMemo, useState } from "react"

import { toast } from "react-hot-toast"
import { Link, Route, Routes } from "react-router-dom"
import { Menu } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import api from "api"
import { useAppSelector } from "store"
import { useDidMount } from "utils/useDidMount"
import util from "utils/utils"

import Planner from "./Planner"
import Settings from "./Settings"

type CalendarResp = OpenAPI.GET<"/challenges/{id}/calendar">["response"]

const PlannerMenu = ({ challenge }) => {
  const [isLoading, setLoading] = useState(true)
  const [calendar, setCalendar] = useState<CalendarResp["calendar"]>(null)
  const challengeId = challenge?._id
  const user = useAppSelector((state) => state.user)

  const getCalendar = useCallback(() => {
    api.challenges.getCalendar(
      challengeId,
      ({ calendar }: CalendarResp) => {
        setCalendar(calendar)
        setLoading(false)
      },
      (error) => {
        toast.error(error.message)
      },
    )
  }, [challengeId])

  useDidMount(() => {
    setLoading(true)
    getCalendar()
  })
  const canManageChallenge = useMemo(() => util.canManageChallenge(user, challenge), [user, challenge])

  return (
    <div>
      <Menu pointing secondary>
        <Menu.Item active={util.activePath("/planner$")} icon="calendar" content="Planner" as={Link} to="." />
        {canManageChallenge || util.hasPermission(user, "challenge.editSettings", challengeId) ? (
          <Menu.Item
            active={util.activePath("/planner/settings")}
            icon="cogs"
            content="Settings"
            as={Link}
            to="settings"
          />
        ) : null}
      </Menu>

      <Routes>
        {canManageChallenge || util.hasPermission(user, "challenge.editSettings", challengeId) ? (
          <Route
            path="settings"
            element={<Settings challenge={challenge} calendar={calendar} setCalendar={setCalendar} />}
          />
        ) : null}
        <Route
          path="/"
          element={
            <Planner
              challenge={challenge}
              calendar={calendar}
              setCalendar={setCalendar}
              getCalendar={getCalendar}
              isLoading={isLoading}
            />
          }
        />
      </Routes>
    </div>
  )
}

export default PlannerMenu
